exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".listGroup{margin:0}.listGroup__item{padding:12px 16px!important;cursor:pointer}>.listGroup__item:last-child{border-bottom:0}.media{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.media p{line-height:1.2em;margin-bottom:.5em}.media .price{color:#1b1761;font-weight:700;font-size:14px;margin-bottom:0}.media .divinationMethod{color:#888;font-size:11px}.media .counselorName{font-weight:700}.media__image{margin-top:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4da88d96","scoped":false,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/FirstcomeShowcase.vue
// module id = 7IJ5
// module chunks = 0